import {translate} from "./translate";

export const translateObject = (t, obj, params = {}) => {
    const result = {};

    Object.entries(obj).map(([name, value]) => {
        result[name] = translate(t, value, params);
    });

    return result;
};
